import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  MainContainer,
  Sidebar,
  ConversationList,
  Conversation,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  Avatar,
  TypingIndicator,
  ConversationHeader,
  InputToolbox
} from "@chatscope/chat-ui-kit-react";
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import { Icon } from '@iconify/react'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import EditIcon from "@mui/icons-material/Edit";
import data from "@emoji-mart/data"
import Picker from "@emoji-mart/react"
import { io, Socket } from "socket.io-client";
import axios from "axios";
import "./style.css";
import apiUrl from "../../../configs/constant";
import {
  Box,
  Typography,
  Stack,
  IconButton,
  Chip,
  TextField,
  InputAdornment,
  Paper,
  DialogActions,
  Button,
  Fab
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import DialogQuotation from '../../../components/omni/DialogQuotation'
import DialogCatatan from '../../../components/omni/DialogCatatan'
import DialogOrder from '../../../components/omni/DialogOrder'
import DialogRingkasan from '../../../components/omni/DialogRingkasan'
import DialogTag from '../../../components/omni/DialogTag'
import DialogActivity from '../../../components/omni/DialogActivity'
import { useVirtualizer } from "@tanstack/react-virtual";
import ContactSkeleton from "./contact-skeleton";
import Swal from "sweetalert2";
import DialogDelivery from "../../../components/omni/DialogDelivery";
import DialogInvoice from "../../../components/omni/DialogInvoice";
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FilerobotImageEditor from "react-filerobot-image-editor";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DialogCreateContact from "./DialogCreateContact";

const supportAgent = {
  id: "support-agent",
  name: "Support",
  avatar: "https://mylittlefairies.online/apple-touch-icon.png"
};

export default function App() {
  window.addEventListener("unhandledrejection", function (event) {
    console.error("PROMISE ERROR:", event.reason);
  });

  const socketRef = useRef<Socket | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const inputWrapperRef = useRef<HTMLDivElement | null>(null);
  const parentRef = useRef<HTMLDivElement>(null);
  const userData = JSON.parse(localStorage.getItem("user")!);
  const token = userData?.token;
  const [listContact, setListContact] = useState<any[]>([]);
  const [selectedContact, setSelectedContact] = useState<any>(null);
  const [chatMessages, setChatMessages] = useState<Record<string, any[]>>({});
  const [typing, setTyping] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [activeDialog, setActiveDialog] = useState<any>(null)
  const [dropdownStyle, setDropdownStyle] = useState<any>({});
  const [inputValue, setInputValue] = useState("");
  const [showSlash, setShowSlash] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [totalUnread, setTotalUnread] = useState(0);

  const [transactions, setTransactions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(search);
  const [showEmoji, setShowEmoji] = useState(false)
  const [anchorElMsg, setAnchorElMsg] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [replyMessage, setReplyMessage] = useState<any>(null);
  const [deleteMessage, setDeleteMessage] = useState<any>(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);
  const [openEditor, setOpenEditor] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  const messageListRef = useRef<HTMLDivElement | null>(null)
  const [showScrollBottom, setShowScrollBottom] = useState(false)
  const [openDialogAwal, setOpenDialogAwal] = useState(false);

  // handle file
  const [previewFile, setPreviewFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [caption, setCaption] = useState("");
  const [openPreview, setOpenPreview] = useState(false);

  const addEmoji = (emoji: any) => {
    setInputValue((prev) => prev + emoji.native)
  }
  const iconMap: Record<string, string> = {
    produk: "mdi:package-variant",
    order: "mdi:cart",
    template: "mdi:message-text"
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && selectedContact) {
        setSelectedContact(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedContact]);

  const scrollToBottom = () => {
    if (!messageListRef.current) return

    messageListRef.current.scrollTo({
      top: messageListRef.current.scrollHeight,
      behavior: "smooth"
    })
  }

  const handleScrollMessage = () => {
    const el = messageListRef.current
    if (!el) return

    const distanceFromBottom =
      el.scrollHeight - el.scrollTop - el.clientHeight

      console.log(distanceFromBottom);
    // tampil kalau user jauh dari bawah
    setShowScrollBottom(distanceFromBottom > 300)
  }

  useEffect(() => {
    setShowScrollBottom(true)
    const handlePaste = (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      for (const item of items) {
        const file = item.getAsFile();
        if (!file) continue;

        // kalau gambar => buka editor
        if (item.type.startsWith("image/")) {
          const url = URL.createObjectURL(file);

          setImageSrc(url);
          setOpenEditor(true);

          e.preventDefault();
          return;
        }

        // kalau file lain => preview + caption
        if (item.kind === "file") {
          const url = URL.createObjectURL(file);

          setPreviewFile(file);
          setPreviewUrl(url);
          setCaption("");
          setOpenPreview(true);

          e.preventDefault();
          return;
        }
      }
    };

    window.addEventListener("paste", handlePaste);

    return () => {
      window.removeEventListener("paste", handlePaste);
    };
  }, []);

  const colorMap: Record<string, string> = {
    promo: "#e91e63",
    produk: "#2196f3",
    order: "#4caf50",
    template: "#9c27b0"
  };
  const staticCommands = [
  ];

  // generate slash command
  const dynamicCommands = transactions.map((t) => ({
    key: `${t.name}`,
    label: t.template,
    type: 'template',
    icon: colorMap['template']
  }));

  // gabungkan dengan static command kalau mau
  const allCommands = [
    ...staticCommands.map(cmd => ({
      ...cmd,
      icon: iconMap[cmd.type] || "mdi:flash"
    })),
    ...dynamicCommands
  ];
  // filter berdasarkan input
const filteredCommands = allCommands
  .map((cmd) => {
    const keyword = inputValue.replace("/", "").toLowerCase();
    const keyText = cmd.key.toLowerCase();
    const labelText = cmd.label.toLowerCase();

    let score = -1;

    // prioritas tertinggi = key diawali keyword
    if (keyText.startsWith(keyword)) score = 1;

    // key mengandung keyword
    else if (keyText.includes(keyword)) score = 2;

    // label diawali keyword
    else if (labelText.startsWith(keyword)) score = 3;

    // label mengandung keyword
    else if (labelText.includes(keyword)) score = 4;

    return { ...cmd, score };
  })
  .filter((cmd) => cmd.score !== -1)
  .sort((a, b) => a.score - b.score);

  // grouping
  const groupedCommands = filteredCommands.reduce((acc: any, cmd) => {
    if (!acc[cmd.type]) acc[cmd.type] = [];
    acc[cmd.type].push(cmd);
    return acc;
  }, {});

  const open = Boolean(anchorEl)
  const closeDialog = () => setActiveDialog(null)

  useEffect(() => {
    getContact();
    getTemplate();
  }, []);

  const handleMenuOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const stringToColor = (str: string) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    const color = `hsl(${hash % 360}, 60%, 55%)`;
    return color;
  };

  const getInitials = (name: string) => {
    if (!name) return "?";

    const words = name
      .trim()
      .split(" ")
      .filter(Boolean);

    if (words.length === 0) return "?";
    if (words.length === 1) return words[0][0].toUpperCase();

    return (
      words[0][0].toUpperCase() +
      words[1][0].toUpperCase()
    );
  };

  const audioRef = useRef(null)
  useEffect(() => {
    audioRef.current = new Audio('https://mylittlefairies.online/sound/ringtone.mp3')
    audioRef.current.preload = 'auto'
  }, [])

  useEffect(() => {
    socketRef.current = io("https://mylittlefairies.online", {
      transports: ["websocket"]
    });
    socketRef.current.on("wa:message", (data) => {
      if (!data) return;

      if (!data.isOutgoing && audioRef.current) {
        audioRef.current.currentTime = 0
        audioRef.current.play().catch(err => {
          console.log('Audio blocked:', err)
        })
      }

      // update message
      if (data.id === selectedContact?.id) {
        addMessage(data);
      }

      // move contact to top
      setListContact((prev) => {
        const exists = prev.some((c) => c.id === data.id);

        // kalau contact belum ada → refresh
        if (!exists) {
          getContact(); // 🔥 refresh list
          return prev;
        }

        const updated = prev.map((c) =>
          c.id === data.id
            ? {
                ...c,
                last_msg: data.text || "["+data.type+"]",
                last_msg_time: data.created_at || new Date(),
                count_not_read: data.isOutgoing ? 0 : (c.count_not_read || 0) + 1 
              }
            : c
        );

        const target = updated.find((c) => c.id === data.id);
        const others = updated.filter((c) => c.id !== data.id);

        return target ? [target, ...others] : prev;
      });
    });

    return () => {
      socketRef.current?.disconnect();
    };
  }, [selectedContact]);

  useEffect(() => {
    if (!showSlash || !inputWrapperRef.current) return;

    const rect = inputWrapperRef.current.getBoundingClientRect();

    setDropdownStyle({
      position: "fixed",
      bottom: window.innerHeight - rect.top + 8,
      left: rect.left + 48,
      width: rect.width - 60
    });
  }, [showSlash, inputValue]);

  const filteredContacts = useMemo(() => {
    let data = [...listContact];

    // filter unread
    if (showUnreadOnly) {
      data = data.filter(
        (c: any) => Number(c.count_not_read || 0) > 0
      );
    }

    // filter search
    if (debouncedSearch.trim()) {
      data = data.filter((c: any) =>
        c.nama
          ?.toLowerCase()
          .includes(debouncedSearch.toLowerCase())
      );
    }

    return data;
  }, [listContact, debouncedSearch, showUnreadOnly]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(search);
    }, 300);

    return () => clearTimeout(timeout);
  }, [search]);

  useEffect(() => {
    if (totalUnread > 0) {
      document.title = `(${totalUnread}) My Little Fairies Chat`;
    } else {
      document.title = "My Little Fairies Chat";
    }
  }, [totalUnread]);

  useEffect(() => {
    const total = listContact.reduce(
      (sum, item) => sum + Number(item.count_not_read || 0),
      0
    );

    setTotalUnread(total);
  }, [listContact]);

  const getContact = async () => {
    setLoading(true)
    const res = await axios.get(
      apiUrl.apiUrl + "/omni/chat/get-contact",
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      setListContact(res.data.data);
      setLoading(false)
    }
  };
  const getTemplate = async () => {
    const res = await axios.get(
      apiUrl.apiUrl + "/omni/chat/get-template",
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      setTransactions(res.data.data);
    }
  };

  const getChatByContact = async (id: string) => {
    const res = await axios.get(
      apiUrl.apiUrl + "/omni/chat/get-chat-by-contact/" + id,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      const data = res.data.data;
      setSelectedContact(data);
      const messages = data.message.map((m: any) => ({
        id: `${m.message_id}`,
        text: m.text,
        type: m.type,
        mediaUrl: m.media_url,
        filename: m.filename,
        caption: m.caption,
        timestamp:m.created_at,
        text_reply:m.text_reply,
        direction: m.is_incoming ? "incoming" : "outgoing",
        sender: m.is_incoming ? m.from_name : supportAgent.name
      }));

      setChatMessages((prev) => ({
        ...prev,
        [data.id]: messages
      }));
    }
  };

  const addMessage = (data: any) => {
    const newMsg = {
      id: data.messageId,
      text: data.text,
      type: data.type,
      mediaUrl: data.mediaUrl,
      caption: data.caption,
      timestamp:Date.now(),
      direction: data.isOutgoing ? "outgoing" : "incoming",
      sender: data.isOutgoing ? supportAgent.name : selectedContact?.nama
    };

    setChatMessages((prev) => ({
      ...prev,
      [selectedContact.id]: [
        ...(prev[selectedContact.id] || []),
        newMsg
      ]
    }));
  };

const htmlToText = (html: string) => {
  const div = document.createElement("div");

  // line break tags
  html = html.replace(/<br\s*\/?>/gi, "\n");

  // block elements jadi newline
  html = html.replace(/<\/(div|p|li|tr|h1|h2|h3|h4|h5|h6)>/gi, "\n");

  // bullet list
  html = html.replace(/<li[^>]*>/gi, "• ");

  // tab untuk table cell
  html = html.replace(/<\/td>\s*<td[^>]*>/gi, "\t");

  div.innerHTML = html;

  let text = div.textContent || "";

  text = text
    .replace(/\r/g, "")
    .replace(/\u00A0/g, " ")          // nbsp
    .replace(/[ \t]+\n/g, "\n")      // spasi sebelum enter
    .replace(/\n[ \t]+/g, "\n")      // spasi setelah enter
    .replace(/\t{2,}/g, "\t")        // tab berlebih
    .replace(/\n{3,}/g, "\n\n")      // max 2 enter
    .replace(/[ ]{2,}/g, " ")        // spasi dobel
    .trim();

  return text;
};

  const sendMessage = async (text: string) => {
    if (!selectedContact) return;
    let cleanText = htmlToText(text).trim();
    let type = "text";
    if(replyMessage != null){
      type = "reply";
    }else if(deleteMessage !=null){
      type = "delete";
    }

    const payload = {
      session_id: selectedContact.session_id,
      to: selectedContact.last_jid,
      message: cleanText,
      type: type,
      quoted_message_id:
      type === 'reply'
        ? replyMessage?.id
        : type === 'delete'
        ? deleteMessage?.id
        : undefined
    };

    await axios.post(apiUrl.waUrl + "/send", payload, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setReplyMessage(null)
    setDeleteMessage(null)

    // const newMsg = {
    //   id: Date.now(),
    //   text: cleanText,
    //   type: "text",
    //   direction: "outgoing",
    //   timestamp:Date.now(),
    //   sender: supportAgent.name
    // };

    // setChatMessages((prev) => ({
    //   ...prev,
    //   [selectedContact.id]: [
    //     ...(prev[selectedContact.id] || []),
    //     newMsg
    //   ]
    // }));
  };

  const detectFileType = (file: File) => {
    if (file.type.startsWith("image/")) return "image";
    if (file.type.startsWith("video/")) return "video";
    if (file.type.startsWith("audio/")) return "audio";
    return "document";
  };

  const sendFile = async (file: File) => {
    if (!selectedContact) return;

    const formData = new FormData();
    formData.append("session_id", selectedContact.session_id);
    formData.append("to", selectedContact.last_jid);
    formData.append("file", file);
    formData.append("type", detectFileType(file));

    const response = await axios.post(
      apiUrl.waUrl + "/send",
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );
  };

  const activeMessages = chatMessages[selectedContact?.id] ?? [];

  const handleClickAction = (el: any) => {  
    if (el.key == "logout") {
      localStorage.removeItem("user");
      window.location.replace("/login");
      return;
    } else if (el.key == "beranda"){
      window.location.href = "/";
      return;
    }else if (el.key === "pindah-salesman") {
      Swal.fire({
        title: "Pilih Salesman",
        input: "select",
        inputOptions: {
          12603000001: "Ana",
          12603000002: "Lulu"
        },
        inputPlaceholder: "Pilih salesman",
        showCancelButton: true,
        confirmButtonText: "Pindahkan",
        cancelButtonText: "Batal",
        inputValidator: (value) => {
          if (!value) {
            return "Silakan pilih salesman";
          }
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          const salesId = result.value;

          try {
            const payload = {};

            await axios.post(
              `${apiUrl.apiUrl}/omni/chat/change-sales/${selectedContact.id}/${salesId}`,
              payload,
              {
                headers: {
                  Authorization: `Bearer ${token}`
                }
              }
            );

            Swal.fire("Berhasil", "Sales berhasil diubah", "success");

            getContact();
            setSelectedContact(null);

          } catch (error) {
            Swal.fire(
              "Gagal",
              error?.response?.data?.message || "Terjadi kesalahan",
              "error"
            );
          }
        }
      });

      return;
    }

    setActiveDialog(el.key);
    handleMenuClose();
  };

  const rowVirtualizer = useVirtualizer({
    count: filteredContacts.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 72, // tinggi 1 Conversation (px)
    overscan: 6
  });

  const handleDropFile = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const file = e.dataTransfer.files?.[0];
    if (!file) return;

    // kalau gambar => buka editor
    if (file.type.startsWith("image/")) {
      const previewUrl = URL.createObjectURL(file);
      setImageSrc(previewUrl);
      setOpenEditor(true);
      return;
    }

    // selain gambar => preview modal
    setPreviewFile(file);
    setPreviewUrl(URL.createObjectURL(file));
    setCaption("");
    setOpenPreview(true);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };


const CHAT_ACTIONS = [
  { key: 'pindah-salesman', label: 'Pindah Salesman', icon: 'mdi:account-switch' },
  { key: 'quotation', label: 'Quotation', icon: 'mdi:file-document-edit' },
  { key: 'order', label: 'Order', icon: 'mdi:cart' },
  { key: 'delivery', label: 'Delivery', icon: 'mdi:truck-delivery' },
  { key: 'invoice', label: 'Invoice', icon: 'mdi:receipt' },
  { key: 'note', label: 'Catatan', icon: 'mdi:note-text' },
  { key: 'tag', label: 'Tag', icon: 'mdi:tag-multiple' },
  { key: 'summary', label: 'Summary', icon: 'mdi:text-box-search' },
  { key: 'schedule', label: 'Jadwal Aktifitas', icon: 'mdi:calendar-clock' },
  { key: 'calender', label: 'Kalender', icon: 'mdi:calendar-month' },
  { key: 'profil', label: 'Profil', icon: 'mdi:account-circle' },
  { key: 'beranda', label: 'Beranda', icon: 'mdi:home' },
  { key: 'logout', label: 'Logout', icon: 'mdi:logout' },

] as const;
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (!showSlash) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) =>
          prev + 1 >= filteredCommands.length ? 0 : prev + 1
        );
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) =>
          prev - 1 < 0 ? filteredCommands.length - 1 : prev - 1
        );
      }

      if (e.key === "Enter") {
        e.preventDefault();
        const cmd = filteredCommands[selectedIndex];
        if (cmd) {
          setInputValue(`/${cmd.key} `);
          setShowSlash(false);
        }
      }

      if (e.key === "Escape") {
        setShowSlash(false);
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [showSlash, selectedIndex, filteredCommands]);

  const handleCommand = (cmd: any) => {
    switch (cmd.type) {
      case "template":
        const text = cmd.label.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>");
        setInputValue(text);
        break;

      default:
        setInputValue(`/${cmd.key}`);
    }

    setShowSlash(false);
  };

  const handlePreviewImage = (url: string) => {
    Swal.fire({
      imageUrl: url,
      imageAlt: "Preview",
      showConfirmButton: false,
      showCloseButton: true,
      background: "#000",
      backdrop: "rgba(0,0,0,0.9)",
      width: "auto",
      padding: "10px",
      customClass: {
        popup: "swal-image-popup"
      }
    });
  };


  const handleSendPreviewFile = async () => {
    if (!previewFile) return;

    const formData = new FormData();
    formData.append("session_id", selectedContact.session_id);
    formData.append("to", selectedContact.last_jid);
    formData.append("file", previewFile);
    formData.append("type", detectFileType(previewFile));
    formData.append("caption", caption);

    await axios.post(apiUrl.waUrl + "/send", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data"
      }
    });

    setOpenPreview(false);
    setPreviewFile(null);
    setCaption("");
  };

  const handleSave = async (editedImageObject: any) => {
    try {
      if (!selectedContact) {
        setOpenEditor(false);
        return;
      }
      
      // ambil base64 hasil edit
      const base64 =
        editedImageObject.imageBase64 ||
        editedImageObject.base64 ||
        editedImageObject.fullName;

      // convert base64 -> blob
      const blob = await (await fetch(base64)).blob();

      // buat file
      const file = new File(
        [blob],
        `edited-${Date.now()}.png`,
        { type: "image/png" }
      );

      // kirim seperti sendFile()
      const formData = new FormData();
      formData.append("session_id", selectedContact.session_id);
      formData.append("to", selectedContact.last_jid);
      formData.append("file", file);
      formData.append("type", "image");

      await axios.post(
        apiUrl.waUrl + "/send",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      setOpenEditor(false);
    } catch (err) {
      console.error("Gagal kirim gambar:", err);
    }
  };

  const renderTextWithLinks = (text) => {
    if (!text) return null;

    const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        const href = part.startsWith("http") ? part : `https://${part}`;

        return (
          <a
            key={index}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#1976d2",
              textDecoration: "underline",
              wordBreak: "break-all"
            }}
          >
            {part}
          </a>
        );
      }

      return <span key={index}>{part}</span>;
    });
  };
  const renderMessageContent = (msg: any) => {
    const renderCaption = () =>
      msg.caption ? (
        <div style={{ marginTop: 6, fontSize: 13 }}>
          {msg.caption}
        </div>
      ) : null;

    switch (msg.type) {
      case "text":
        return <span>{renderTextWithLinks(msg.text)}</span>;
      case "reply":
        const reply = msg.reply_to;
        return (
          <div>
            <div
              style={{
                borderLeft: "4px solid #25D366",
                background: "#f0f0f0",
                padding: "6px 8px",
                borderRadius: 8,
                marginBottom: 4,
                cursor: "pointer"
              }}
              onClick={() => console.log("scroll")}
            >
              <div style={{ fontSize: 12, fontWeight: 600, color: "#25D366" }}>
                {reply?.sender || "You"}
              </div>

              {reply?.type === "image" ? (
                <div style={{ fontSize: 12 }}>📷 Photo</div>
              ) : (
                <div style={{ fontSize: 12 }}>{msg.text_reply}</div>
              )}
            </div>

            <div>{renderTextWithLinks(msg.text)}</div>
          </div>
        );
      case "reaction":
        const reaction = msg.reply_to;

        return (
          <div>
            <div
              style={{
                borderLeft: "4px solid #25D366",
                background: "#f0f0f0",
                padding: "6px 8px",
                borderRadius: 8,
                marginBottom: 4,
                cursor: "pointer"
              }}
              onClick={() => console.log("scroll")}
            >
              <div style={{ fontSize: 12, fontWeight: 600, color: "#25D366" }}>
                {reaction?.sender || "You"}
              </div>

              <div style={{ fontSize: 12 }}>{msg.text_reply}</div>
            </div>

            <div>{msg.text}</div>
          </div>
        );
      case "image":
        const url = msg.mediaUrl?.startsWith("http")
          ? msg.mediaUrl
          : `${apiUrl.BASE_URL}${msg.mediaUrl}`;
        return (
          <div>
            <img
              src={url}
              alt="image"
              onClick={() => handlePreviewImage(url)}
              style={{
                maxWidth: 240,
                borderRadius: 12,
                cursor: "pointer",
                objectFit: "cover"
              }}
            />
            {renderCaption()}
          </div>
        );

      case "video":
        return (
          <div>
            <video
              src={msg.media_url}
              controls
              style={{
                maxWidth: 260,
                borderRadius: 12
              }}
            />
            {renderCaption()}
          </div>
        );

      case "audio":
        return (
          <div>
            <audio controls style={{ width: 250 }}>
              <source src={msg.media_url} />
            </audio>
            {renderCaption()}
          </div>
        );

      case "document":
        const urlDocument = msg.mediaUrl?.startsWith("http")
          ? msg.mediaUrl
          : `${apiUrl.BASE_URL}${msg.mediaUrl}`;

        return (
          <div>
            <a
              href={urlDocument}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: 10,
                borderRadius: 10,
                background: "#ffffff",
                border: "1px solid #e5e5e5",
                textDecoration: "none",
                color: "#111",
                maxWidth: 320,
                minWidth: 260
              }}
            >
              {/* icon kiri */}
              <div
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: 8,
                  background: "#e8f5e9",
                  color: "#25D366",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 22,
                  fontWeight: 700,
                  flexShrink: 0
                }}
              >
                📄
              </div>

              {/* isi */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {msg.fileName || "Document"}
                </div>

                <div
                  style={{
                    fontSize: 12,
                    color: "#667781",
                    marginTop: 3
                  }}
                >
                  Document
                </div>
              </div>

              {/* tombol download */}
              <div
                style={{
                  color: "#667781",
                  fontSize: 18,
                  flexShrink: 0
                }}
              >
                ⬇
              </div>
            </a>

            {renderCaption()}
          </div>
        );

      case "sticker":
        const urlSticker = msg.mediaUrl?.startsWith("http")
          ? msg.mediaUrl
          : `${apiUrl.BASE_URL}${msg.mediaUrl}`;
        return (
          <div>
            <img
              src={urlSticker}
              alt="sticker"
              style={{
                width: 120,
                height: 120
              }}
            />
            {renderCaption()}
          </div>
        );

      case "location":
        const [lat, lng] = (msg.text || "").split(",");

        return (
          <div>
            <iframe
              width="250"
              height="150"
              style={{ borderRadius: 12, border: 0 }}
              loading="lazy"
              src={`https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`}
            />
            <div style={{ marginTop: 6, fontSize: 12 }}>
              📍 {lat}, {lng}
            </div>
            {renderCaption()}
          </div>
        );

      case "contact":
        return (
          <div
            style={{
              padding: 12,
              borderRadius: 12,
              background: "#f0f2f5",
              maxWidth: 250
            }}
          >
            <div style={{ fontWeight: 600 }}>
              {msg.contactName}
            </div>
            <div style={{ fontSize: 13, opacity: 0.7 }}>
              📞 {msg.phone}
            </div>
            {renderCaption()}
          </div>
        );

      default:
        return (
          <div style={{ opacity: 0.6 }}>
            ❓ Unsupported message type: {msg.type}
          </div>
        );
    }
  };

  const truncate = (text: string, max = 40) => {
    if (!text) return "";
    return text.length > max ? text.slice(0, max) + "..." : text;
  };

  const formatTimeWA = (time:any) => {
    if (!time) return "";

    const now:any = new Date();
    const msg:any = new Date(time);

    const diffTime = now - msg;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    // hari ini
    if (diffDays === 0 && now.getDate() === msg.getDate()) {
      // hari ini
      return msg.toLocaleTimeString("id-ID", {
        hour: "2-digit",
        minute: "2-digit"
      });
    }

    // kemarin
    if (diffDays === 1) {
      return `Yesterday ${msg.toLocaleTimeString("id-ID", {
        hour: "2-digit",
        minute: "2-digit"
      })}`;
    }

    // dalam 7 hari
    if (diffDays < 7) {
      return `${msg.toLocaleDateString("id-ID", {
        weekday: "short"
      })} ${msg.toLocaleTimeString("id-ID", {
        hour: "2-digit",
        minute: "2-digit"
      })}`;
    }

    // lebih lama
    return `${msg.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    })} ${msg.toLocaleTimeString("id-ID", {
      hour: "2-digit",
      minute: "2-digit"
    })}`;
  };

const mapType = [
  '[image]',
  '[video]',
  '[sticker]',
  '[reaction]',
  '[document]'
]

const emojiMap: any = {
  '[image]': '🖼️',
  '[video]': '🎥',
  '[sticker]': '😀',
  '[reaction]': '😊',
  '[document]': '📄'
}

const renderLastMessage = (msg: any) => {
  if (!msg) return ''

  if (!mapType.includes(msg)) {
    return msg
  }

  const emoji = emojiMap[msg] || '📄'

  switch (msg) {
    case '[image]':
      return `${emoji} Foto`

    case '[video]':
      return `${emoji} Video`

    case '[sticker]':
      return `${emoji} Stiker`

    case '[reaction]':
      return `${emoji} Reaksi`

    case '[document]':
      return `${emoji} Dokumen`

    default:
      return `${emoji} File`
  }
}

  return (
    <MainContainer style={{ height: "100vh", width: "100%" }}>
      {/* SIDEBAR */}
      <Sidebar
        position="left"
        scrollable={false}
        style={{
          width: 320,
          borderRight: "1px solid #e0e0e0",
          backgroundColor: "#ffffff"
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #f0f0f0"
          }}
        >
          <img
            src="https://api.mylittlefairies.online/images/mlfc.png"
            alt="MLF"
            style={{
              height: 32,
              width: "auto",
              objectFit: "contain"
            }}
          />

          <Stack direction="row" spacing={1}>
            <IconButton size="small" onClick={()=> {
              getContact()
            }}>
              <RefreshIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={()=> {
              setOpenDialogAwal(true)
            }}>
              <AddIcon fontSize="small" />
            </IconButton>
            <IconButton size="small">
              <MoreVertIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Box>

        {/* SEARCH */}
        <Box sx={{ px: 2, py: 1.5 }}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search contact or chat"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "20px",
                backgroundColor: "#f0f2f5",
                "& fieldset": { border: "none" }
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              )
            }}
          />
        </Box>

        {/* FILTER */}
        <Stack
          direction="row"
          spacing={1}
          sx={{ px: 2, pb: 1 }}
        >
          <Chip
            label={`Semua`}
            clickable
            onClick={() => setShowUnreadOnly(false)}
            color={!showUnreadOnly ? "success" : "default"}
            variant={!showUnreadOnly ? "filled" : "outlined"}
            sx={{
              borderRadius: "16px",
              fontWeight: 500
            }}
          />

          <Chip
            label={`Belum Dibaca (${totalUnread})`}
            clickable
            onClick={() => setShowUnreadOnly(true)}
            color={showUnreadOnly ? "primary" : "default"}
            variant={showUnreadOnly ? "filled" : "outlined"}
            sx={{ borderRadius: "16px" }}
          />
        </Stack>
        <input
          type="file"
          style={{ display: "none" }}
          ref={fileInputRef}
          accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (!file) return;

            // reset value supaya file sama bisa dipilih ulang
            e.target.value = "";

            // kalau gambar -> buka editor dulu
            if (file.type.startsWith("image/")) {
              const previewUrl = URL.createObjectURL(file);

              setImageSrc(previewUrl);   // source untuk Filerobot
              setOpenEditor(true);      // buka editor
              return;
            }

            // selain gambar => preview modal
            setPreviewFile(file);
            setPreviewUrl(URL.createObjectURL(file));
            setCaption("");
            setOpenPreview(true);
            // sendFile(file);
          }}
        />

        {/* LIST */}
        <ConversationList
          style={{
            borderTop: "1px solid #f5f5f5",
            padding: 0
          }}
        >
          {loading ? (
            <>
              {Array.from({ length: 8 }).map((_, i) => (
                <ContactSkeleton key={i} />
              ))}
            </>
          ) : (
            <div
              ref={parentRef}
              style={{
                height: 450,
                overflow: "auto"
              }}
            >
              <div
                style={{
                  height: rowVirtualizer.getTotalSize(),
                  position: "relative"
                }}
              >
                {rowVirtualizer.getVirtualItems().map((virtualRow) => {
                  const c = filteredContacts[virtualRow.index];
                  return (
                    <div
                      key={c.id}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: virtualRow.size,
                        transform: `translateY(${virtualRow.start}px)`
                      }}
                    >
                      <Conversation
                        unreadCnt={c.count_not_read || 0}
                        active={selectedContact?.id === c.id}
                        onClick={() => {
                          setListContact((prev) =>
                            prev.map((x) =>
                              x.id === c.id ? { ...x, count_not_read: 0 } : x
                            )
                          );

                          getChatByContact(c.id);
                          setTimeout(() => {
                            const el = document.querySelector(".cs-message-input__content-editor");

                            if (el instanceof HTMLElement) {
                              el.focus();
                            }
                          }, 0);
                        }}
                        style={{
                          padding: "12px 16px",
                          transition: "all 0.2s ease"
                        }}
                      >
                        <Avatar
                          style={{
                            backgroundColor: stringToColor(c.nama),
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: 600,
                            width: 40,
                            height: 40,
                            fontSize: 14
                          }}
                        >
                          {getInitials(c.nama)}
                        </Avatar>

                        <Conversation.Content
                          name={
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%"
                              }}
                            >
                              <span>
                                {c.nama?.length > 18
                                  ? c.nama.substring(0, 18) + "..."
                                  : c.nama}
                              </span>
                              <span style={{ fontSize: 12, color: "#999" }}>
                                {formatTimeWA(c.last_msg_time)}
                              </span>
                            </div>
                          }
                          info={
                            <span
                              style={{
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                              }}
                            >
                              {renderLastMessage(c.last_msg)}
                            </span>
                          }
                        />
                      </Conversation>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </ConversationList>
      </Sidebar>

      {/* CHAT AREA */}
      <ChatContainer 
        onDrop={handleDropFile}
        onDragOver={handleDragOver}
      >
        <ConversationHeader
          style={{
            borderBottom: "1px solid #eaeaea",
            backgroundColor: "#f8f9fa"
          }}
        >
          <ConversationHeader.Content
            userName={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  flexWrap: "wrap"
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {selectedContact?.nama || "Select Contact"}
                </span>
                {selectedContact && (
                  <EditIcon
                    sx={{
                      fontSize: 18,
                      cursor: "pointer",
                      color: "#666",
                      "&:hover": { color: "#1976d2" }
                    }}
                    onClick={async () => {
                      const result = await Swal.fire({
                        title: "Edit Nama Contact",
                        input: "text",
                        inputValue: selectedContact.nama || "",
                        inputLabel: "Nama Baru",
                        inputPlaceholder: "Masukkan nama",
                        showCancelButton: true,
                        confirmButtonText: "Simpan",
                        cancelButtonText: "Batal"
                      });

                      if (result.isConfirmed && result.value) {
                        try {
                          const payload = {
                            nama: result.value
                          };

                          await axios.post(
                            `${apiUrl.apiUrl}/omni/chat/change-name/${selectedContact.id}`,
                            payload,
                            {
                              headers: {
                                Authorization: `Bearer ${token}`
                              }
                            }
                          );

                          Swal.fire("Berhasil", "Nama berhasil diubah", "success");
                          getContact()
                          getChatByContact(selectedContact.id)
                        } catch (error) {
                          Swal.fire("Error", "Gagal ubah nama", "error");
                        }
                      }
                    }}
                  />
                )}

                {selectedContact?.tags?.map((el: any, index: number) => (
                  <Chip
                    key={index}
                    size="small"
                    variant="filled"
                    clickable
                    onClick={() => handleClickAction({ key: "tag" })}
                    icon={
                      el?.icon ? (
                        <Icon icon={el.icon} width={12} />
                      ) : undefined
                    }
                    label={el?.name}
                    sx={{
                      bgcolor: el?.hex_color || "#1976d2",
                      color: "#fff",
                      fontWeight: 600,
                      height: 20,
                      fontSize: 10,
                      px: 0.5,
                      cursor: "pointer",
                      transition: "0.2s",
                      "&:hover": {
                        opacity: 0.85
                      },
                      "& .MuiChip-label": {
                        px: 0.8
                      },
                      "& .MuiChip-icon": {
                        fontSize: 12,
                        ml: "4px",
                        color: "#fff"
                      }
                    }}
                  />
                ))}
              </div>
            }
            info={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  flexWrap: "wrap"
                }}
              >
                <span>{selectedContact?.phone || ""}</span>

                <span style={{ color: "#999" }}>|</span>

                <span>{selectedContact?.nama2 || "-"}</span>

                {selectedContact && (
                  <EditIcon
                    sx={{
                      fontSize: 18,
                      cursor: "pointer",
                      color: "#666",
                      "&:hover": { color: "#1976d2" }
                    }}
                    onClick={async () => {
                      const result = await Swal.fire({
                        title: "Edit Keterangan Contact",
                        input: "text",
                        inputValue: selectedContact.nama2 || "",
                        inputLabel: "Keterangan Baru",
                        inputPlaceholder: "Masukkan keterangan",
                        showCancelButton: true,
                        confirmButtonText: "Simpan",
                        cancelButtonText: "Batal"
                      });

                      if (result.isConfirmed && result.value) {
                        try {
                          const payload = {
                            nama: result.value
                          };

                          await axios.post(
                            `${apiUrl.apiUrl}/omni/chat/change-name2/${selectedContact.id}`,
                            payload,
                            {
                              headers: {
                                Authorization: `Bearer ${token}`
                              }
                            }
                          );

                          Swal.fire("Berhasil", "Nama berhasil diubah", "success");

                          getContact();
                          getChatByContact(selectedContact.id);
                        } catch (error) {
                          Swal.fire("Error", "Gagal ubah nama", "error");
                        }
                      }
                    }}
                  />
                )}
              </div>
            }
          />

          <ConversationHeader.Actions>
            <IconButton size="small">
              <SearchIcon fontSize="small" />
            </IconButton>

            <div className="chat-actions">
              <IconButton size="small" onClick={handleMenuOpen}>
                <MoreVertIcon fontSize="small" />
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
              >
                {CHAT_ACTIONS.map((a) => (
                  <MenuItem
                    key={a.label}
                    onClick={() => handleClickAction(a)}
                  >
                    <ListItemIcon>
                      <Icon icon={a.icon} />
                    </ListItemIcon>
                    <ListItemText primary={a.label} />
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </ConversationHeader.Actions>
        </ConversationHeader>
        {selectedContact ? (
        <MessageList
          ref={messageListRef}
          onScroll={handleScrollMessage}
          style={{
            backgroundImage: "url('https://mylittlefairies.online/background/bg-chat.png')",
            backgroundSize: "cover",      // supaya penuh
            backgroundPosition: "center", // posisi tengah
            backgroundRepeat: "no-repeat" // jangan diulang
          }}
          typingIndicator={
            typing ? (
              <TypingIndicator content="Typing..." />
            ) : null
          }
        >
          {activeMessages.map((msg) => {
            const url = msg.mediaUrl?.startsWith("http")
              ? msg.mediaUrl
              : `${apiUrl.BASE_URL}${msg.mediaUrl}`;

            const caption =
              msg.caption !== undefined && msg.caption !== null ? (
                <div style={{ marginTop: 5, fontSize: 12 }}>
                  {msg.caption}
                </div>
              ) : null;

            return (
              <Message
                key={msg.id}
                model={{
                  direction: msg.direction,
                  position: "single",
                  sender: msg.sender
                }}
              >
                <Message.CustomContent>
                  <div
                  style={{
                    position: "relative",
                    paddingRight: 25   // space untuk icon
                  }}
                  onContextMenu={(e) => {
                    e.preventDefault();
                    setSelectedMessage(msg);
                    setAnchorElMsg(e.currentTarget);
                  }}
                  onMouseEnter={(e) => {
                    const btn = e.currentTarget.querySelector(".menuBtn") as HTMLElement | null;
                    if (btn) btn.style.opacity = "1";
                  }}

                  onMouseLeave={(e) => {
                    const btn = e.currentTarget.querySelector(".menuBtn") as HTMLElement | null;
                    if (btn) btn.style.opacity = "0";
                  }}
                >
                  {renderMessageContent(msg)}

                  <IconButton
                    className="menuBtn"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();        // penting biar tidak trigger parent
                      setSelectedMessage(msg);    // simpan message yg diklik
                      setAnchorElMsg(e.currentTarget); // posisi menu
                    }}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      padding: 2,
                      opacity: 0,
                      transition: "0.2s"
                    }}
                  >
                    <Icon icon="mdi:chevron-down" width={18} />
                  </IconButton>
                </div>
                </Message.CustomContent>
                <Message.Footer sentTime={formatTimeWA(msg.timestamp)} />
              </Message>
            );
          })}
        </MessageList>
        ):(
        <MessageList style={{ height: "100%", backgroundImage: "url('https://mylittlefairies.online/background/bg-chat.png')",
            backgroundSize: "cover",      // supaya penuh
            backgroundPosition: "center", // posisi tengah
            backgroundRepeat: "no-repeat" // jangan diulang
            }}>
          <Message
          style={{
            alignItems: "center",
            justifyContent: "center",
            marginTop:50,
          }}
            model={{
              direction: "incoming",
              position: "single",
              sender: "System"
            }}
          >
            <Message.CustomContent>
              <div
                style={{
                  minHeight: "70vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    background: "#ffffff",
                    padding: "40px 50px",
                    textAlign: "center",
                  }}
                >
                  <img
                    src="https://api.mylittlefairies.online/images/mlfc.png"
                    style={{
                      width: 220,
                      marginBottom: 20,
                      opacity: 0.95
                    }}
                  />

                  <div
                    style={{
                      fontSize: 20,
                      fontWeight: 600,
                      color: "#111b21",
                      marginBottom: 8
                    }}
                  >
                    MLF OMNICHANNEL
                  </div>

                  <div
                    style={{
                      fontSize: 14,
                      color: "#667781",
                      lineHeight: 1.6
                    }}
                  >
                    Pilih percakapan untuk mulai mengirim pesan
                  </div>

                  <div
                    style={{
                      marginTop: 20,
                      fontSize: 12,
                      color: "#8696a0"
                    }}
                  >
                    Pesan Anda terenkripsi end-to-end 🔒
                  </div>
                </div>
              </div>
            </Message.CustomContent>
          </Message>
        </MessageList>
        )}
        {showScrollBottom && (
          <Fab
            size="small"
            onClick={scrollToBottom}
            sx={{
              position: "absolute",
              bottom: 90,
              right: 20,
              zIndex: 999,
              bgcolor: "#ffffff",
              boxShadow: 3,
              "&:hover": {
                bgcolor: "#f5f5f5"
              }
            }}
          >
            <KeyboardArrowDownIcon />
          </Fab>
        )}
        <InputToolbox
          style={{
            display: "flex",
            alignItems: "flex-end",
            gap: 8,
            padding: "4px 8px"
          }}
        >
          {/* EMOJI BUTTON */}
          <div style={{ position: "relative" }}>
            <IconButton
              onClick={() => setShowEmoji(!showEmoji)}
            >
              <Icon icon={"mdi:emoticon"} width={24} />
            </IconButton>

            {showEmoji && (
              <div
                style={{
                  position: "absolute",
                  bottom: "45px",
                  left: 0,
                  zIndex: 20
                }}
              >
                <Picker
                  data={data}
                  onEmojiSelect={addEmoji}
                  theme="light"
                />
              </div>
            )}
          </div>

          {/* INPUT AREA */}
          <div style={{ position: "relative", flex: 1 }}>

            {showSlash && filteredCommands.length > 0 && (
              <Paper
                elevation={8}
                sx={{
                  position: "absolute",
                  bottom: "calc(100% + 10px)",
                  left: 0,
                  width: "400px",
                  borderRadius: 3,
                  maxHeight: 320,
                  overflowY: "auto",
                  zIndex: 10,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
                  p: 1
                }}
              >
                {Object.entries(groupedCommands).map(([group, items]: any) => (
                  <Box key={group} sx={{ mb: 1 }}>
                    <Typography
                      variant="caption"
                      sx={{
                        px: 1,
                        py: 0.5,
                        fontWeight: 700,
                        color: "text.secondary",
                        textTransform: "uppercase"
                      }}
                    >
                      {group}
                    </Typography>

                    {items.map((cmd: any) => (
                      <Box
                        key={cmd.key}
                        onClick={() => handleCommand(cmd)}
                        sx={{
                          px: 1.5,
                          py: 1,
                          borderRadius: 2,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          "&:hover": { backgroundColor: "action.hover" }
                        }}
                      >
                        <Icon
                          icon={cmd.icon}
                          width="18"
                          color={colorMap[cmd.type]}
                        />

                        <Box>
                          <Typography fontWeight={600} fontSize={14}>
                            /{cmd.key}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {cmd.label}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ))}
              </Paper>
            )}
            {replyMessage && (
              <Box
                sx={{
                  bgcolor: "#f5f5f5",
                  borderLeft: "4px solid #2196F3",
                  borderRadius: 1,
                  px: 1.5,
                  py: 1,
                  mb: 0.5,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <Box sx={{ overflow: "hidden" }}>
                  <Typography fontSize={12} fontWeight={600}>
                    {replyMessage.sender || "User"}
                  </Typography>
                  <Typography
                    fontSize={12}
                    color="text.secondary"
                    noWrap
                  >
                    {truncate(replyMessage.text || "[Media]", 40)}
                  </Typography>
                </Box>

                <IconButton
                  size="small"
                  onClick={() => setReplyMessage(null)}
                >
                  <Icon icon="mdi:close" width={16} />
                </IconButton>
              </Box>
            )}
            <MessageInput
              value={inputValue}
              placeholder='ketik "Shift + Enter" untuk baris baru. Ketik "/" untuk Balas Cepat'
              onChange={(val) => {
                setInputValue(val)
                setShowSlash(val.startsWith("/"))
              }}
              onSend={(val) => {
                if (val.startsWith("/")) return
                sendMessage(val)
                setInputValue("")
              }}
              attachButton
              onAttachClick={() => fileInputRef.current?.click()}
            />

          </div>

        </InputToolbox>
      </ChatContainer>
      <Menu
        anchorEl={anchorElMsg}
        open={Boolean(anchorElMsg)}
        onClose={() => setAnchorElMsg(null)}
        PaperProps={{
          sx: {
            borderRadius: 2,
            minWidth: 160,
            py: 0.5,
            boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            "& .MuiMenuItem-root": {
              px: 1.5,
              py: 1,
              gap: 1,
              fontSize: 13
            }
          }
        }}
      >
        <MenuItem
          onClick={() => {
            setReplyMessage(selectedMessage);
            setAnchorElMsg(null);
            setTimeout(() => {
              const el = document.querySelector(".cs-message-input__content-editor");

              if (el instanceof HTMLElement) {
                el.focus();
              }
            }, 0);
          }}
        >
          <Icon icon="mdi:reply" width={18} />
          Reply
        </MenuItem>

        <MenuItem
          onClick={() => {
            navigator.clipboard.writeText(selectedMessage?.text || "");
            setAnchorElMsg(null);
          }}
        >
          <Icon icon="mdi:content-copy" width={18} />
          Copy
        </MenuItem>

        <MenuItem
          onClick={() => {
            setDeleteMessage(selectedMessage);
            setOpenDelete(true);
            setAnchorElMsg(null);
          }}
          sx={{ color: "error.main" }}
        >
          <Icon icon="mdi:delete-outline" width={18} />
          Delete
        </MenuItem>
      </Menu>
      <Dialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        PaperProps={{
          sx: { borderRadius: 3, minWidth: 320 }
        }}
      >
        <DialogTitle sx={{ p: 2 }}>
          <Typography fontSize={18} fontWeight={600}>
            Konfirmasi hapus
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Typography fontSize={14} color="text.secondary">
            Pesan ini akan dihapus apakah anda yakin?.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 2, pb: 2 }}>
          <Button
            onClick={() => {
              setDeleteMessage(null)
              setOpenDelete(false)
            }}
            variant="text"
          >
            Cancel
          </Button>

          <Button
            color="error"
            variant="contained"
            onClick={() => {
              sendMessage("");
              setOpenDelete(false);
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Quotation */}
      <DialogQuotation
        open={activeDialog === 'quotation'}
        contact={selectedContact}
        onClose={closeDialog}
      />

      {/* TAG */}
      <DialogTag
        open={activeDialog === 'tag'}
        contact={selectedContact}
        onClose={closeDialog}
        onReload={() => getChatByContact(selectedContact?.id)}
      />

      {/* RINGKASAN */}
      <DialogRingkasan
        open={activeDialog === 'summary'}
        contact={selectedContact}
        onClose={closeDialog}
        onReload={() => {
          getContact()
          getChatByContact(selectedContact?.id)
        }}
      />

      {/* ORDER */}
      <DialogOrder
        open={activeDialog === 'order'}
        contact={selectedContact}
        onClose={closeDialog}
      />

      {/* DELIVERY */}
      <DialogDelivery
        open={activeDialog === 'delivery'}
        contact={selectedContact}
        onClose={closeDialog}
      />

      {/* INVOICE */}
      <DialogInvoice
        open={activeDialog === 'invoice'}
        contact={selectedContact}
        onClose={closeDialog}
      />

      {/* CATATAN */}
      <DialogCatatan
        open={activeDialog === 'note'}
        contact={selectedContact}
        onClose={closeDialog}
      />

      {/* JADWAL AKTIVITAS */}
      <DialogActivity
        open={activeDialog === 'schedule'}
        contact={selectedContact}
        onClose={closeDialog}
      />
      <Dialog open={openEditor} fullScreen>
        <style>{`
          .FIE_save-modal.SfxModal-Container{
            position:fixed !important;
            top:50% !important;
            left:50% !important;
            transform:translate(-50%,-50%) !important;
            z-index:999999 !important;
          }

          .SfxModal-Wrapper{
            position:fixed !important;
            inset:0 !important;
            z-index:999998 !important;
          }

          .SfxModal-Overlay{
            position:fixed !important;
            inset:0 !important;
          }
        `}</style>
        <FilerobotImageEditor
          source={imageSrc}
          onSave={handleSave}
          onClose={() => setOpenEditor(false)}
          savingPixelRatio={1}
          previewPixelRatio={1}
          language="en"
          useBackendTranslations={false}
        />
      </Dialog>

      <Dialog
        open={openPreview}
        fullWidth
        maxWidth="sm"
        onClose={() => setOpenPreview(false)}
      >
        <Box p={2}>
          <Typography fontWeight={700} mb={2}>
            Preview File
          </Typography>

          <Box
            sx={{
              border: "1px solid #eee",
              borderRadius: 2,
              p: 2,
              display: "flex",
              alignItems: "center",
              gap: 2
            }}
          >
            <div style={{ fontSize: 40 }}>📄</div>

            <div>
              <div style={{ fontWeight: 600 }}>{previewFile?.name}</div>
              <div style={{ fontSize: 13, color: "#666" }}>
                {(previewFile?.size / 1024).toFixed(1)} KB
              </div>
            </div>
          </Box>

          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder="Tambahkan caption..."
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
            sx={{ mt: 2 }}
          />

          <Box
            mt={2}
            display="flex"
            justifyContent="flex-end"
            gap={1}
          >
            <Button onClick={() => setOpenPreview(false)}>
              Batal
            </Button>

            <Button
              variant="contained"
              onClick={handleSendPreviewFile}
            >
              Kirim
            </Button>
          </Box>
        </Box>
      </Dialog>
      <DialogCreateContact
        token={token}
        open={openDialogAwal}
        onClose={() => setOpenDialogAwal(false)}
        getContact={getContact}
      />
    </MainContainer>
  );
}